import {MARKET_SORT_ORDER, Market, MarketCodeEnums} from 'models/Market';

export const sortMarkets = (a: Market, b: Market) => {
  const sortIndexA = MARKET_SORT_ORDER.indexOf(a.id);
  const sortIndexB = MARKET_SORT_ORDER.indexOf(b.id);

  const hasSortIndexA = sortIndexA !== -1;
  const hasSortIndexB = sortIndexB !== -1;

  // international is always last
  if (a.id === MarketCodeEnums.INTERNATIONAL) {
    return 1;
  }

  if (b.id === MarketCodeEnums.INTERNATIONAL) {
    return -1;
  }

  // at least one of the markets has a specified sort order
  if (hasSortIndexA || hasSortIndexB) {
    // market A has a sort order, market B does not - sort A first
    if (!hasSortIndexB) {
      return -1;
    }

    // market B has a sort order, market A does not - sort B first
    if (!hasSortIndexA) {
      return 1;
    }

    // both have sort orders, determine which comes first
    return sortIndexA - sortIndexB;
  }

  // neither market has a specific sort order, sort by name
  return a.name < b.name ? -1 : b.name < a.name ? 1 : 0;
};
